import React, {useEffect, useRef} from 'react';
import ScrollToBottom from "react-scroll-to-bottom";
import styled from "styled-components";
import {fetchPreviousMessagesConversation, setMessageOfConversation} from "./utils";
import {useBotTrackedState, useBotDispatch} from "./BotStore";
import Loading, {useLoading} from "./Loading";
import {getChatIdentifier} from "../Auth";
import BotTaskMessages from "./BotTaskMessages";

const Scroll = styled(ScrollToBottom)`
    height: 500px;
    visibility: ${props => (props.visibility ? props.visibility : "visible")};;
`;

type Props = {
    visibility: string;
}

function BotTaskList({visibility = "visible"}: Props) {
    const dispatch = useBotDispatch();
    const state = useBotTrackedState();
    const identity = getChatIdentifier();
    const {conversation, messages, isReviewing} = state;
    const {loading, setLoading} = useLoading();
    const mounted = useRef(false);

    useEffect(() => {
        if (mounted.current) return;
        if (!mounted.current && messages.length > 0) {
            mounted.current = true;
            setLoading(false);
            return;
        }
        if (messages.length > 0) return;
        if (conversation) {
            mounted.current = true;
            fetchPreviousMessagesConversation(conversation, 30)
                .then(({messages, hasPrevPage, lastIndex, previousIndex}) => {
                    dispatch({
                        type: "SET_INITIAL_MESSAGES",
                        messages: messages,
                        previousIndex: previousIndex,
                        hasPreviousPage: hasPrevPage,
                        lastIndex: lastIndex
                    });
                    setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                    console.error({fetchPreviousMessages: error});
                });
        }
    }, [conversation, dispatch, setLoading, messages.length]);

    useEffect(() => {
        const abortController = new AbortController();
        if (conversation) {
            conversation.on("messageAdded", async message => {
                let newMessage = await setMessageOfConversation(message);
                dispatch({type: "MESSAGE_ADDED", message: newMessage});
            });

            conversation.on("messageUpdated", async ({message}) => {
                // @ts-ignore
                if (message.sid && message.attributes["archived"] === true) {
                    dispatch({type: "MESSAGE_REMOVED", sid: message.sid});
                } else {
                    let updatedMessage = await setMessageOfConversation(message);
                    dispatch({type: "MESSAGE_UPDATED", message: updatedMessage});
                }
            });

            conversation.on("messageRemoved", async message => {
                // @ts-ignore
                if (message.state.sid) {
                    dispatch({type: "MESSAGE_REMOVED", sid: message.sid});
                }
            });
        }
        return () => {
            abortController.abort();
        };
    }, [dispatch, conversation]);

    if (loading) {
        return <Loading containerHeight={'500px'}/>
    }

    if (isReviewing) return null;

    return (
        <Scroll visibility={visibility}>
            <BotTaskMessages identity={identity!}/>
        </Scroll>
    );
}

export default BotTaskList;